import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MultiButtonConfirmationModal from './multi-button-confirmation-modal';
import { GreenroomState as GS } from '../../../stores/types/types';
import * as ModalActions from '../../../stores/actions/modal';
import Socket from '../../../connection/socket';
import type { ChatPost } from '../../../stores/types/chat';
import { makeId } from '../../../stores/reducers/chat';
import { SoftDeleteChatMessageById } from '../../../connection/chat';
import { removeChatMessage } from '../../../stores/actions/chat';

interface Props {
	chatPost: ChatPost;
	socket: Socket | null;
}

export default function DeleteChatMessageConfirmation({ chatPost, socket }: Props) {
	const dispatch = useDispatch();

	const user = useSelector((s: GS) => s.SessionReducer.user);
	const token = useSelector((s: GS) => s.SessionReducer.token);
	const meeting = useSelector((s: GS) => s.SessionReducer.meeting);
	const session = useSelector((s: GS) => s.SessionReducer.session);

	const closeModal = () => {
		dispatch(ModalActions.setModalState({ modalOpen: false }));
	};

	const deleteMessage = async () => {
		if (!token || !user || !meeting) return;

		const deleted = await SoftDeleteChatMessageById(token, meeting.meeting, chatPost.id);

		if (deleted) {
			const dmKey = makeId([chatPost.sender?.email ?? '', chatPost.recipient?.email ?? '']);
			dispatch(removeChatMessage(chatPost.id, chatPost.room, dmKey));
			socket?.sendMessage(
				'remove-chat-message',
				{
					from: session,
					messageId: chatPost.id,
					roomId: chatPost.room,
					dmKey,
				},
			);
		}

		dispatch(ModalActions.setModalState({ modalOpen: false }));
	};

	return (
		<MultiButtonConfirmationModal
			headerText="Delete chat message?"
			bodyText="You won't be able to recover it."
			firstButtonText="Cancel"
			firstButtonAction={closeModal}
			secondButtonText="Delete"
			secondButtonAction={deleteMessage}
			className="delete-chat-message-confirmation"
			isOpen
		/>
	);
}
